import { endpoints } from "@app/api/apis";
import { useAppSelector } from "@app/store/hooks";
import { RootState } from "@app/store/newstore";
import { useIsFocused } from "@react-navigation/native";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const useCurrentApplicationDetails = () => {

    const [currentApplicationDetails, setCurrentApplicationDetails] = useState<any>(null);
    const [currentApplicationDetailsLoading, setIsLoading] = useState(true);
    const userDetails = useAppSelector((state: RootState) => state.auth.userDetails);
    const isFocused = useIsFocused();

    const getCurrentApplicationDetails = useCallback(async () => {
        setIsLoading(true);
        try {
          axios.get(`${endpoints.enhanceLimitApplicationDetailsV2}${userDetails?.linkedCredits[0]?.creditId}`)
          .then((res)=>{
            setCurrentApplicationDetails(res.data);
          }).catch(err=>{
            console.log("Error:", err);
          })
        } catch (error: any) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
      }, [userDetails]);

    useEffect(() => {
        getCurrentApplicationDetails();
    }, [isFocused]);

    return { currentApplicationDetails, currentApplicationDetailsLoading };
}
